import {Ref, RefCallback, RefObject} from 'react';

type RefType<T> = Ref<T> | RefObject<T>;

/**
 * Safely merges multiple refs into one
 * @param refs - Array of refs to merge
 * @returns A single ref callback that sets all provided refs
 * @example
 * const {availableWidth, availableWidthRef} = useAvailableWidth<HTMLDivElement>();
 * const myRef = useRef<HTMLDivElement>(null);
 *
 * return <Box ref={mergeRefs(availableWidthRef, myRef)} width={availableWidth} />;
 */
export function mergeRefs<T>(...refs: Array<RefType<T> | undefined>): RefCallback<T> {
  return (value: T) => {
    refs.forEach((ref) => {
      if (typeof ref === 'function') {
        ref(value);
      } else if (ref != null) {
        (ref as RefObject<T>).current = value;
      }
    });
  };
}
